import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "./Footer";
import SEO from "../components/SEO";
import { organizationSchema, websiteSchema } from "../components/structuredData";
import Project from "./Project";
import bgImage from "../video/background.mp4";
import { useSiteConfig } from "../contexts/SiteConfigContext";

// const API_URL = "http://localhost:8080";
const API_URL= "https://backend-ged-immo.onrender.com"

export default function Home() {
  const { config } = useSiteConfig();
  const hero = config.hero;
  const about = config.about;
  const [homes, setHomes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/homes`)
      .then(res => setHomes(res.data.homes || []))
      .catch(err => console.error("Erreur fetch homes:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <p style={{ padding: 80, textAlign: "center" }}>Chargement…</p>;
  }

  return (
    <div>
      <SEO
        title="Immobilier en Côte d'Ivoire — Vente & Location"
        description="SCI MAYEDO — Découvrez nos villas, appartements et bureaux à vendre ou à louer à Abidjan et partout en Côte d'Ivoire. Biens de prestige, accompagnement personnalisé."
        canonical="/"
        structuredData={[organizationSchema, websiteSchema]}
      />
      <Navbar />

      <div className="main--part">
        <video autoPlay loop muted>
          <source src={bgImage} />
        </video>
        <div className="slogan">
          <h2 className='slogan__title'>{hero.title}</h2>
          <p>{hero.subtitle}</p>
          <Link to={hero.cta_url} className="hero-cta-link">
            <button className="hero-cta-btn">
              <span className="hero-cta-btn__icon"><i className="fa-solid fa-arrow-right"></i></span>
              <span className="hero-cta-btn__text">{hero.cta_label}</span>
            </button>
          </Link>

          <style>{`
            .hero-cta-link { text-decoration: none; display: inline-block; margin-top: 2rem; }

            .hero-cta-btn {
              display: inline-flex;
              align-items: center;
              gap: 12px;
              padding: 16px 36px;
              background: rgba(255, 255, 255, 0.15);
              color: #fff;
              font-size: 1.05rem;
              font-weight: 700;
              letter-spacing: 0.04em;
              border: 2px solid rgba(255,255,255,0.7);
              border-radius: 50px;
              cursor: pointer;
              backdrop-filter: blur(10px);
              box-shadow: 0 8px 32px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.3);
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;
            }

            .hero-cta-btn::before {
              content: '';
              position: absolute;
              inset: 0;
              background: linear-gradient(135deg, rgba(255,255,255,0.18), rgba(255,255,255,0));
              border-radius: 50px;
              opacity: 0;
              transition: opacity 0.3s ease;
            }

            .hero-cta-btn:hover {
              background: rgba(255,255,255,0.28);
              border-color: #fff;
              transform: translateY(-3px);
              box-shadow: 0 16px 48px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.4);
            }

            .hero-cta-btn:hover::before { opacity: 1; }

            .hero-cta-btn:active { transform: translateY(-1px); }

            .hero-cta-btn__icon {
              width: 36px;
              height: 36px;
              background: #fff;
              color: #1B4F9E;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.9rem;
              flex-shrink: 0;
              transition: transform 0.3s ease;
              box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            }

            .hero-cta-btn:hover .hero-cta-btn__icon {
              transform: translateX(4px);
            }

            .hero-cta-btn__text { position: relative; z-index: 1; }
          `}</style>
        </div>
      </div>

      {/* ================== COUPS DE COEUR ================== */}
      <div className="container">
        <h3 className="top--houses">Notre sélection de coups de coeur</h3>
        <div className="cards-grid">
          {homes
            ?.slice(-3)
            .map((home) => (
              <div key={home._id} className="cards">
                <Link to={`/details/${home._id}`} className="card-image-wrapper">
                  <img
                    src={
                      Array.isArray(home.img)
                        ? (home.img[0]?.startsWith("http") ? home.img[0] : `${API_URL}/${home.img[0]}`)
                        : (home.img?.startsWith("http") ? home.img : `${API_URL}/${home.img}`)
                    }
                    alt={home.nameHome || home.name}
                  />
                  {/* 🔴🟢 BADGE STATUT */}
                  {/* <span
                    className={`status-badge ${
                      home.state === "Disponible" || home.disponible ? "available" : "occupied"
                    }`}
                  >
                    {home.state || (home.disponible ? "Disponible" : "Occupée")}
                  </span> */}
                </Link>

                <div className="cards-content">
                  <strong>{home.nameHome || home.name}</strong>
                  <p>{home.city}</p>
                  <p>{home.addressHome}</p>
                  <p>Nombre de pièces : {home.NmbrePieces}</p>
                  <p className="price">
                    <span>{home.rent?.toLocaleString()} FCFA / mois</span>
                  </p>
                  <Link to={`/details/${home._id}`}>
                    <button className="more--details">Voir l'annonce</button>
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* ================== DESCRIPTION ENTREPRISE ================== */}
      <div className="description--enterprise">
        <div className="description--enterprise--content--left">
          <h1 className="name--enterprise">{about.title}</h1>
          {about.slogan && <p><em>{about.slogan}</em></p>}
          <p>{about.text}</p>
        </div>
        <div className="description--enterprise--content--right">
          <img src="/images/17.jpeg" alt="Maison" />
        </div>
      </div>

      <Project/>

      {/* ================== CONTACT ================== */}
      <div className="question--part">
        <div className="question--part--content">
          <h3 className='question'>À la recherche d’un appartement, d’une villa à louer ou à vendre?</h3>
          <div className="question--part--btn">
            <Link className='liste' to="/contact"> 
              <button className="btn--contact">Contactez-nous !</button>
            </Link>
          </div>
        </div>
      </div>

      <Footer/>

      <style>{`
        .cards-grid {
          display: flex;
          gap: 1.8rem;
          height:auto;
          align-items:center;
            margin-bottom:1rem;
            flex-wrap:wrap
            justify-content:center
        }

        .cards {
          background: #fff;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0,0,0,.08);
          transition: .3s;
          height:450px;
          text-align:center;
        
        }

        .cards:hover {
          transform: translateY(-4px);
        }

        .cards img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        .cards-content {
          padding: 16px;
        }

        .price {
          color: rgb(12, 52, 103);
          font-weight: bold;
        }

        .card-image-wrapper {
          position: relative;
          display: block;
        }

        .status-badge {
          position: absolute;
          top: 12px;
          left: 12px;
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 600;
          border-radius: 20px;
          color: #fff;
          z-index: 2;
          box-shadow: 0 4px 10px rgba(0,0,0,.25);
        }

        .status-badge.available {
          background: #16a34a;
        }

        .status-badge.occupied {
          background: #dc2626;
        }
          /* ===== RESPONSIVE ===== */
  @media (max-width: 640px) {
    .cards-grid {
      display: block;
      padding:1rem
    }
    .cards img {
      height: 170px;
    }
  }

  @media (min-width: 641px) and (max-width: 1024px) {
    .cards-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .cards img {
      height: 180px;
    }
  }

  @media (min-width: 1025px) and (max-width: 1280px) {
    .cards-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (min-width: 1281px) {
    .cards-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
        
      `}</style>
    </div>
  );
}